import { DEVICES, MOBILE_OPTIONS, LUCKY } from '../editor-ui/constants';
import { DEFAULT_TIME_ZONE } from '../utils/date';

export const initialContext = {
  device: DEVICES.DESKTOP,
  mobile: MOBILE_OPTIONS.filter((x) => !x.disabled)[0].value,
  editor: {
    pages: [],
  },
  voice: LUCKY,
  canUndo: false,
  canRedo: false,
  isDirty: false,
  wordsChanged: 0,
  imagesChanged: 0,
  userId: null,
  userEmail: '',
  timeZone: DEFAULT_TIME_ZONE,
  saved: false,
  saving: false,
  generatorVoiceUsed: null,
  doneManualEdits: false,
  segmentChanged: false,
  edited: {
    content_area: false,
    ai_rephrase: false,
    ai_image: false,
    ai_fix: false,
    manual_image: false,
    image_dimensions: false,
    content_inline: false,
    text_style: false,
    font_size: false,
    font: false,
    color: false,
    alignment: false,
    add_link: false,
    advanced: false,
    checks_failed_max: 0,
    checks_failed_final: 0,
  },
  pagesOpen: true,
  versionsOpen: false,
  controlsOpen: true,
  brandCheckResultsOpen: true,
  urlToLoad: null,
  interactiveMode: false,
  hasPublishPermissions: false,
  apiError: null,
  brandGuidelines: null,
  brandCheckResults: null,
  checksTargetEl: null,
  failedElSelected: false,
  runningCheckRefs: {},
  shouldRunCheckImmediately: false,
};
